import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-quill/dist/quill.snow.css";
import 'react-image-lightbox/style.css';

import App from './App';
import { Provider } from "react-redux";
import store from './feaures/store/Index';

import Laoder from "./components/Loader"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <Suspense fallback={<Laoder />}>
        <App />
      </Suspense>
    </Provider>
);


